import axios from 'axios'
import { useQuery } from 'react-query'

// const mockToken =
// 	'eyJraWQiOiJPYXV0aERvbWFpbiIsIng1dCI6Inp4VmZfVnctc2d4VWwxNlYxU0VONmtKTDQ5USIsImFsZyI6IlJTMjU2In0.eyJpc3MiOiJodHRwOi8vaXAtMTAtMjAyLTEwLTIzOS5sb2NhbC52ZWxvZS5jb20uYnI6MTQxMDAvb2F1dGgyIiwiYXVkIjoiUG9ydGFsIiwiZXhwIjoxNjUwMzE3ODM4LCJqdGkiOiIxY1ViVWxWTExSS3FpT2x6eEFwTDdBIiwiaWF0IjoxNjUwMzEwNjM4LCJzdWIiOiJQb3J0YWxDbGllbnQiLCJjbGllbnQiOiJQb3J0YWxDbGllbnQiLCJzY29wZSI6WyJQb3J0YWwudmVsb2UiXSwiZG9tYWluIjoiT2F1dGhEb21haW4ifQ.arHPK66cdIcHfnJnoG-QlHzSigezUFKPOD7edu-xwjTh1Uav75f3oRCYbnaDmrg1w126vNohYqfOqmDFvevXxPO6JcutKrH5aRFx01D6wi0hSPhog3E99yRRTsV8026_fcwGRaYHUWrcc_fwC3jJJ0aTf1JQbxNtKW_Y995B62Q-60b3ri7j-zFS63Tz0bcjXdHWKRZxRIykdsdXKQbGtfG8YJ0ci64t4EMFDVnmsLUb80rIhrDSOks2Q3MhXjPq3seA_oRnzPen75vM7UsTahALdCrT1Qgk4eQwBt0Kam6GBdBVCNuozRtwXtoEmM5R9eNC91UcmiiS1oBQ8tWLtw'

export const useAuth = () => {
	const url =
		process.env.REACT_APP_MIDDLEWARE_URL || 'https://middleware.veloe.com.br'
	return useQuery('getToken', () => axios.post(`${url}/auth/token`), {
		onSuccess: ({ data }) => {
			localStorage.setItem('token', data.access_token)
			// localStorage.setItem('token', mockToken)
		}
	})
}
